/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "apiMPPHeader",
            "endpoint": "https://x9o1k3lp33.execute-api.us-west-2.amazonaws.com/devintent",
            "region": "us-west-2"
        },
        {
            "name": "devintent",
            "endpoint": "https://vl33pgrnj2.execute-api.us-west-2.amazonaws.com/devintent",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:b3f2f4d8-6727-41a3-9f9f-7bc7f29f98c0",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_O5JVZUh6e",
    "aws_user_pools_web_client_id": "6kpuholp94qmvqgh7de28bka07",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
